import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'android-keystore-generator',
    loadComponent: () =>
      import(
        './components/android-keystore-generator/android-keystore-generator.component'
      ).then(m => m.AndroidKeystoreGeneratorComponent),
  },
  {
    path: 'ios-certificate-generator',
    loadComponent: () =>
      import(
        './components/ios-certificate-generator/ios-certificate-generator.component'
      ).then(m => m.IosCertificateGeneratorComponent),
  },
  {
    path: 'ios-udid-finder',
    loadComponent: () =>
      import('./components/ios-udid-finder/ios-udid-finder.component').then(
        m => m.IosUdidFinderComponent,
      ),
  },
  {
    path: '**',
    loadChildren: () => import('../not-found/routes').then(m => m.routes),
  },
];
